<template>
  <v-expand-transition>
    <div v-if="saverbarActive">
      <v-card class="pa-4 primary_lighten5 flex-row flex-wrap" flat>
        <div class="d-flex justify-end px-2">
          <v-btn class="mr-4" color="info" outlined @click="setCancelChanges">{{
            $t('Common.cancel')
          }}</v-btn>
          <v-btn color="info" @click="setSaveChanges">{{ $t('Common.save') }}</v-btn>
        </div>
      </v-card>
    </div>
  </v-expand-transition>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SaverBar',
  computed: {
    ...mapState(['saverbarActive']),
  },
  methods: {
    ...mapActions(['setSaveChanges', 'setCancelChanges']),
  },
};
</script>

<style scoped></style>
